import { Sweetnesses } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function EditPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Wine Sweetnesses", href: "/sweetnesses" },
          { title: "Edit Wine Sweetness", href: `/sweetnesses/edit/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Edit Wine Sweetness</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Sweetnesses.Edit id={id} />
        </div>
      </div>
    </div>
  );
}
